! function(e) {
    "function" == typeof define && define.amd ? define([], e) : "undefined" != typeof module && null !== module && module.exports ? module.exports = e : e()
}(function() {
    function e(e) {
        return new CustomEvent(e, P)
    }

    function t(e) {
        return e[B] || (e[B] = {})
    }

    function n(e, n, i, o, a) {
        function c(e) {
            i(e, o)
        }
        n = n.split(O);
        for (var u, r = t(e), d = n.length; d--;)(r[u = n[d]] || (r[u] = [])).push([i, c]), e.addEventListener(u, c)
    }

    function i(e, n, i, o) {
        n = n.split(O);
        var a, c, u, r = t(e),
            d = n.length;
        if (r)
            for (; d--;)
                if (a = n[d], c = r[a])
                    for (u = c.length; u--;) c[u][0] === i && (e.removeEventListener(a, c[u][1]), c.splice(u, 1))
    }

    function o(t, n, i) {
        var o = e(n);
        i && L(o, i), t.dispatchEvent(o)
    }

    function a(e) {
        function t(e) {
            i ? (n(), C(t), o = !0, i = !1) : o = !1
        }
        var n = e,
            i = !1,
            o = !1;
        this.kick = function(e) {
            i = !0, o || t()
        }, this.end = function(e) {
            var t = n;
            e && (o ? (n = i ? function() {
                t(), e()
            } : e, i = !0) : e())
        }
    }

    function c() {}

    function u(e) {
        e.preventDefault()
    }

    function r(e) {
        return !!D[e.target.tagName.toLowerCase()]
    }

    function d(e) {
        return 1 === e.which && !e.ctrlKey && !e.altKey
    }

    function m(e, t) {
        var n, i;
        if (e.identifiedTouch) return e.identifiedTouch(t);
        for (n = -1, i = e.length; ++n < i;)
            if (e[n].identifier === t) return e[n]
    }

    function f(e, t) {
        var n = m(e.changedTouches, t.identifier);
        if (n && (n.pageX !== t.pageX || n.pageY !== t.pageY)) return n
    }

    function v(e) {
        d(e) && (r(e) || (n(document, N.move, s, e), n(document, N.cancel, l, e)))
    }

    function s(e, t) {
        y(e, t, e, g)
    }

    function l(e, t) {
        g()
    }

    function g() {
        i(document, N.move, s), i(document, N.cancel, l)
    }

    function p(e) {
        if (!D[e.target.tagName.toLowerCase()]) {
            var t = e.changedTouches[0],
                i = {
                    target: t.target,
                    pageX: t.pageX,
                    pageY: t.pageY,
                    identifier: t.identifier,
                    touchmove: function(e, t) {
                        h(e, t)
                    },
                    touchend: function(e, t) {
                        X(e, t)
                    }
                };
            n(document, z.move, i.touchmove, i), n(document, z.cancel, i.touchend, i)
        }
    }

    function h(e, t) {
        var n = f(e, t);
        n && y(e, t, n, Y)
    }

    function X(e, t) {
        m(e.changedTouches, t.identifier) && Y(t)
    }

    function Y(e) {
        i(document, z.move, e.touchmove), i(document, z.cancel, e.touchend)
    }

    function y(e, t, n, i) {
        var o = n.pageX - t.pageX,
            a = n.pageY - t.pageY;
        o * o + a * a < R * R || w(e, t, n, o, a, i)
    }

    function w(e, t, n, i, a, u) {
        var r = e.targetTouches,
            d = e.timeStamp - t.timeStamp,
            m = {
                altKey: e.altKey,
                ctrlKey: e.ctrlKey,
                shiftKey: e.shiftKey,
                startX: t.pageX,
                startY: t.pageY,
                distX: i,
                distY: a,
                deltaX: i,
                deltaY: a,
                pageX: n.pageX,
                pageY: n.pageY,
                velocityX: i / d,
                velocityY: a / d,
                identifier: t.identifier,
                targetTouches: r,
                finger: r ? r.length : 1,
                enableMove: function() {
                    this.moveEnabled = !0, this.enableMove = c, e.preventDefault()
                }
            };
        o(t.target, "movestart", m), u(t)
    }

    function T(e, t) {
        var n = t.timer;
        t.touch = e, t.timeStamp = e.timeStamp, n.kick()
    }

    function b(e, t) {
        var n = t.target,
            o = t.event,
            a = t.timer;
        S(), Q(n, o, a, function() {
            setTimeout(function() {
                i(n, "click", u)
            }, 0)
        })
    }

    function S() {
        i(document, N.move, T), i(document, N.end, b)
    }

    function k(e, t) {
        var n = t.event,
            i = t.timer,
            o = f(e, n);
        o && (e.preventDefault(), n.targetTouches = e.targetTouches, t.touch = o, t.timeStamp = e.timeStamp, i.kick())
    }

    function K(e, t) {
        var n = t.target,
            i = t.event,
            o = t.timer;
        m(e.changedTouches, i.identifier) && (j(t), Q(n, i, o))
    }

    function j(e) {
        i(document, z.move, e.activeTouchmove), i(document, z.end, e.activeTouchend)
    }

    function E(e, t, n) {
        var i = n - e.timeStamp;
        e.distX = t.pageX - e.startX, e.distY = t.pageY - e.startY, e.deltaX = t.pageX - e.pageX, e.deltaY = t.pageY - e.pageY, e.velocityX = .3 * e.velocityX + .7 * e.deltaX / i, e.velocityY = .3 * e.velocityY + .7 * e.deltaY / i, e.pageX = t.pageX, e.pageY = t.pageY
    }

    function Q(e, t, n, i) {
        n.end(function() {
            return o(e, "moveend", t), i && i()
        })
    }

    function q(e) {
        function t(e) {
            E(i, c.touch, c.timeStamp), o(c.target, "move", i)
        }
        if (!e.defaultPrevented && e.moveEnabled) {
            var i = {
                    startX: e.startX,
                    startY: e.startY,
                    pageX: e.pageX,
                    pageY: e.pageY,
                    distX: e.distX,
                    distY: e.distY,
                    deltaX: e.deltaX,
                    deltaY: e.deltaY,
                    velocityX: e.velocityX,
                    velocityY: e.velocityY,
                    identifier: e.identifier,
                    targetTouches: e.targetTouches,
                    finger: e.finger
                },
                c = {
                    target: e.target,
                    event: i,
                    timer: new a(t),
                    touch: void 0,
                    timeStamp: e.timeStamp
                };
            void 0 === e.identifier ? (n(e.target, "click", u), n(document, N.move, T, c), n(document, N.end, b, c)) : (c.activeTouchmove = function(e, t) {
                k(e, t)
            }, c.activeTouchend = function(e, t) {
                K(e, t)
            }, n(document, z.move, c.activeTouchmove, c), n(document, z.end, c.activeTouchend, c))
        }
    }

    function A(e) {
        e.enableMove()
    }

    function F(e) {
        e.enableMove()
    }

    function M(e) {
        e.enableMove()
    }

    function x(e) {
        var t = e.handler;
        e.handler = function(e) {
            for (var n, i = G.length; i--;) e[n = G[i]] = e.originalEvent[n];
            t.apply(this, arguments)
        }
    }
    var L = Object.assign || window.jQuery && jQuery.extend,
        R = 8,
        C = function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e, t) {
                return window.setTimeout(function() {
                    e()
                }, 25)
            }
        }(),
        D = {
            textarea: !0,
            input: !0,
            select: !0,
            button: !0
        },
        N = {
            move: "mousemove",
            cancel: "mouseup dragstart",
            end: "mouseup"
        },
        z = {
            move: "touchmove",
            cancel: "touchend",
            end: "touchend"
        },
        O = /\s+/,
        P = {
            bubbles: !0,
            cancelable: !0
        },
        B = Symbol("events");
    if (n(document, "mousedown", v), n(document, "touchstart", p), n(document, "movestart", q), window.jQuery) {
        var G = "startX startY pageX pageY distX distY deltaX deltaY velocityX velocityY".split(" ");
        jQuery.event.special.movestart = {
            setup: function() {
                return n(this, "movestart", A), !1
            },
            teardown: function() {
                return i(this, "movestart", A), !1
            },
            add: x
        }, jQuery.event.special.move = {
            setup: function() {
                return n(this, "movestart", F), !1
            },
            teardown: function() {
                return i(this, "movestart", F), !1
            },
            add: x
        }, jQuery.event.special.moveend = {
            setup: function() {
                return n(this, "movestart", M), !1
            },
            teardown: function() {
                return i(this, "movestart", M), !1
            },
            add: x
        }
    }
});


! function(e, t) {
    function n(t) {
        var n, o = e(t.ownerDocument);
        return t = e(t), n = t.offset(), {
            x: n.left + t.outerWidth() / 2 - o.scrollLeft(),
            y: n.top + t.outerHeight() / 2 - o.scrollTop()
        }
    }

    function o(t) {
        var n, o = e(t.ownerDocument);
        return t = e(t), n = t.offset(), {
            x: n.left - o.scrollLeft(),
            y: n.top - o.scrollTop()
        }
    }
    var c = /^key/,
        i = /^(?:mouse|contextmenu)|click/;
    e.fn.simulate = function(t, n) {
        return this.each(function() {
            new e.simulate(this, t, n)
        })
    }, e.simulate = function(t, n, o) {
        var c = e.camelCase("simulate-" + n);
        this.target = t, this.options = o, this[c] ? this[c]() : this.simulateEvent(t, n, o)
    }, e.extend(e.simulate, {
        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            NUMPAD_ADD: 107,
            NUMPAD_DECIMAL: 110,
            NUMPAD_DIVIDE: 111,
            NUMPAD_ENTER: 108,
            NUMPAD_MULTIPLY: 106,
            NUMPAD_SUBTRACT: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        },
        buttonCode: {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2
        }
    }), e.extend(e.simulate.prototype, {
        simulateEvent: function(e, t, n) {
            var o = this.createEvent(t, n);
            this.dispatchEvent(e, t, o, n)
        },
        createEvent: function(e, t) {
            return c.test(e) ? this.keyEvent(e, t) : i.test(e) ? this.mouseEvent(e, t) : void 0
        },
        mouseEvent: function(t, n) {
            var o, c, i, r;
            return n = e.extend({
                bubbles: !0,
                cancelable: "mousemove" !== t,
                view: window,
                detail: 0,
                screenX: 0,
                screenY: 0,
                clientX: 1,
                clientY: 1,
                ctrlKey: !1,
                altKey: !1,
                shiftKey: !1,
                metaKey: !1,
                button: 0,
                relatedTarget: void 0
            }, n), document.createEvent ? ((o = document.createEvent("MouseEvents")).initMouseEvent(t, n.bubbles, n.cancelable, n.view, n.detail, n.screenX, n.screenY, n.clientX, n.clientY, n.ctrlKey, n.altKey, n.shiftKey, n.metaKey, n.button, n.relatedTarget || document.body.parentNode), 0 === o.pageX && 0 === o.pageY && Object.defineProperty && (c = o.relatedTarget.ownerDocument || document, i = c.documentElement, r = c.body, Object.defineProperty(o, "pageX", {
                get: function() {
                    return n.clientX + (i && i.scrollLeft || r && r.scrollLeft || 0) - (i && i.clientLeft || r && r.clientLeft || 0)
                }
            }), Object.defineProperty(o, "pageY", {
                get: function() {
                    return n.clientY + (i && i.scrollTop || r && r.scrollTop || 0) - (i && i.clientTop || r && r.clientTop || 0)
                }
            }))) : document.createEventObject && (o = document.createEventObject(), e.extend(o, n), o.button = {
                0: 1,
                1: 4,
                2: 2
            }[o.button] || (-1 === o.button ? 0 : o.button)), o
        },
        keyEvent: function(t, n) {
            var o;
            if (n = e.extend({
                    bubbles: !0,
                    cancelable: !0,
                    view: window,
                    ctrlKey: !1,
                    altKey: !1,
                    shiftKey: !1,
                    metaKey: !1,
                    keyCode: 0,
                    charCode: void 0
                }, n), document.createEvent) try {
                (o = document.createEvent("KeyEvents")).initKeyEvent(t, n.bubbles, n.cancelable, n.view, n.ctrlKey, n.altKey, n.shiftKey, n.metaKey, n.keyCode, n.charCode)
            } catch (c) {
                (o = document.createEvent("Events")).initEvent(t, n.bubbles, n.cancelable), e.extend(o, {
                    view: n.view,
                    ctrlKey: n.ctrlKey,
                    altKey: n.altKey,
                    shiftKey: n.shiftKey,
                    metaKey: n.metaKey,
                    keyCode: n.keyCode,
                    charCode: n.charCode
                })
            } else document.createEventObject && (o = document.createEventObject(), e.extend(o, n));
            return (/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()) || "[object Opera]" === {}.toString.call(window.opera)) && (o.keyCode = n.charCode > 0 ? n.charCode : n.keyCode, o.charCode = void 0), o
        },
        dispatchEvent: function(e, t, n) {
            e[t] ? e[t]() : e.dispatchEvent ? e.dispatchEvent(n) : e.fireEvent && e.fireEvent("on" + t, n)
        },
        simulateFocus: function() {
            function t() {
                o = !0
            }
            var n, o = !1,
                c = e(this.target);
            c.bind("focus", t), c[0].focus(), o || ((n = e.Event("focusin")).preventDefault(), c.trigger(n), c.triggerHandler("focus")), c.unbind("focus", t)
        },
        simulateBlur: function() {
            function t() {
                o = !0
            }
            var n, o = !1,
                c = e(this.target);
            c.bind("blur", t), c[0].blur(), setTimeout(function() {
                c[0].ownerDocument.activeElement === c[0] && c[0].ownerDocument.body.focus(), o || ((n = e.Event("focusout")).preventDefault(), c.trigger(n), c.triggerHandler("blur")), c.unbind("blur", t)
            }, 1)
        }
    }), e.extend(e.simulate.prototype, {
        simulateDrag: function() {
            var t = 0,
                c = this.target,
                i = this.options,
                r = "corner" === i.handle ? o(c) : n(c),
                u = Math.floor(r.x),
                a = Math.floor(r.y),
                l = {
                    clientX: u,
                    clientY: a
                },
                s = i.dx || (void 0 !== i.x ? i.x - u : 0),
                d = i.dy || (void 0 !== i.y ? i.y - a : 0),
                v = i.moves || 3;
            for (this.simulateEvent(c, "mousedown", l); t < v; t++) u += s / v, a += d / v, l = {
                clientX: Math.round(u),
                clientY: Math.round(a)
            }, this.simulateEvent(c.ownerDocument, "mousemove", l);
            e.contains(document, c) ? (this.simulateEvent(c, "mouseup", l), this.simulateEvent(c, "click", l)) : this.simulateEvent(document, "mouseup", l)
        }
    })
}(jQuery);


;
(function($) {

    $.fn.twentytwenty = function(options) {
        var options = $.extend({
            default_offset_pct: 1,
            orientation: 'horizontal',
            before_label: 'Before',
            after_label: 'After',
            no_overlay: false
        }, options);
        return this.each(function() {

            var sliderPct = options.default_offset_pct;
            var container = $(this);
            var sliderOrientation = options.orientation;
            var beforeDirection = (sliderOrientation === 'vertical') ? 'down' : 'left';
            var afterDirection = (sliderOrientation === 'vertical') ? 'up' : 'right';


            container.wrap("<div class='twentytwenty-wrapper twentytwenty-" + sliderOrientation + "'></div>");
            if (!options.no_overlay) {
                container.append("<div class='twentytwenty-overlay'></div>");
            }
            var beforeImg = container.find("img:first");
            var afterImg = container.find("img:last");
            container.append("<div class='twentytwenty-handle'></div>");
            var slider = container.find(".twentytwenty-handle");
            slider.append("<img src='http://cdn.sandals.com/sandals/v12/images/weddings/global/drag-icon.png'/>");
            slider.after("<span class='twentytwenty-reveal'><span class='reveal-inner'><i class='ic ic-button-arrow-prev'></i>Reveal</span></span>");
            var reveal = container.find('.twentytwenty-reveal');
            container.addClass("twentytwenty-container");
            beforeImg.addClass("twentytwenty-before");
            afterImg.addClass("twentytwenty-after");

            var overlay = container.find(".twentytwenty-overlay");
            overlay.append("<div class='twentytwenty-before-label' data-content='" + options.before_label + "'></div>");
            overlay.append("<div class='twentytwenty-after-label' data-content='" + options.after_label + "'></div>");

            var calcOffset = function(dimensionPct) {
                var w = beforeImg.width();
                var h = beforeImg.height();
                return {
                    w: w + "px",
                    h: h + "px",
                    cw: (dimensionPct * w) + "px",
                    ch: (dimensionPct * h) + "px"
                };
            };

            var adjustContainer = function(offset) {
                if (sliderOrientation === 'vertical') {
                    beforeImg.css("clip", "rect(0," + offset.w + "," + offset.ch + ",0)");
                    afterImg.css("clip", "rect(" + offset.ch + "," + offset.w + "," + offset.h + ",0)");
                } else {
                    beforeImg.css("clip", "rect(0," + offset.cw + "," + offset.h + ",0)");
                    afterImg.css("clip", "rect(0," + offset.w + "," + offset.h + "," + offset.cw + ")");
                }
                container.css("height", offset.h);
            };

            var adjustSlider = function(pct) {
                var offset = calcOffset(pct);
                slider.css((sliderOrientation === "vertical") ? "top" : "left", (sliderOrientation === "vertical") ? offset.ch : offset.cw);
                reveal.css((sliderOrientation === "vertical") ? "top" : "left", (sliderOrientation === "vertical") ? offset.ch : offset.cw);
                adjustContainer(offset);
            };

            $(window).on("resize.twentytwenty", function(e) {
                adjustSlider(sliderPct);
            });

            var offsetX = 0;
            var offsetY = 0;
            var imgWidth = 0;
            var imgHeight = 0;

            slider.on("movestart", function(e) {
                if (((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) && sliderOrientation !== 'vertical') {
                    e.preventDefault();
                } else if (((e.distX < e.distY && e.distX < -e.distY) || (e.distX > e.distY && e.distX > -e.distY)) && sliderOrientation === 'vertical') {
                    e.preventDefault();
                }
                container.addClass("active");
                offsetX = container.offset().left;
                offsetY = container.offset().top;
                imgWidth = beforeImg.width();
                imgHeight = beforeImg.height();
            });

            slider.on("moveend", function(e) {
                container.removeClass("active");
            });

            slider.on("move", function(e) {
                if (container.hasClass("active")) {
                    sliderPct = (sliderOrientation === 'vertical') ? (e.pageY - offsetY) / imgHeight : (e.pageX - offsetX) / imgWidth;
                    if (sliderPct < 0) {
                        sliderPct = 0;
                    }
                    if (sliderPct > 1) {
                        sliderPct = 1;
                    }
                    adjustSlider(sliderPct);
                }
            });

            $(window).on("slidein", function(e, pct) {
                $({
                    slide: 100
                }).animate({
                    slide: pct
                }, {
                    duration: 2000,
                    step: function(val) {
                        adjustSlider(val / 100)
                    }
                })
            });

            container.find("img").on("mousedown", function(event) {
                event.preventDefault();
            });

            $(window).trigger("resize.twentytwenty");
        });
    };

})(jQuery);
